import {
  Form,
  Spin,
  Table,
  Row,
  Input,
  Icon,
  Button,
  Dropdown,
  Menu,
  Popconfirm,
  Empty,
} from "antd";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { TicketCategoryService } from "../../services/ticketCategory/TicketCategoryService";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import "./TicketCategory.css";
import Highlighter from "react-highlight-words";
import { showSuccessToast } from "../general/ToastHelper";
import { convertTZToLocal } from "../general/DateTzHelper";
import CreateTicketCategoryForm from "./CreateTicketCategoryForm";
import history from "../../utils/history";
import { Translation } from "react-i18next";
import i18next from "i18next";
class TicketCategories extends Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("TicketCategories");
    this.state = {
      isFetching: false,
      data: [],
      visible: false,
      loading: false,
      searchText: "",
      edit: false,
      ticketCategoryData: null,
      recordData: null,
    };
    this.ticketCategoryService = new TicketCategoryService();
  }

  componentDidMount() {
    this.getAllTicketCategories();
    this.setState({ edit: false });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }

  async getAllTicketCategories() {
    try {
      this.setState({ isFetching: true });

      let data = await this.ticketCategoryService.getAllTicketCategoryService(
        this.props.context.session_id,
        this.props.context.user.accountId
      );
      this.setState({ data: this.formatData(data), isFetching: false });
    } catch (e) {
      this.setState({ isFetching: false });

      handleError(e);
    }
  }
  handleRefresh() {
    this.getAllTicketCategories();
  }

  async deleteRecord(record) {
    try {
      let data = await this.ticketCategoryService.deleteTicketCategory(
        this.props.context.session_id,
        record.id
      );
      showSuccessToast(i18next.t("Ticket Category deleted successfully"));
      this.handleRefresh();
    } catch (e) {
      handleError(e);
    }
  }

  addNewTicketCategory = () => {
    history.push("/home/ticketCategories/create");
  };

  showCreateTicketCategoryForm = () => {
    let { history } = this.props;
    history.push(
      "/home/ticketCategories/create/" + this.props.context.user.accountId
    );
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };

  renderActionDropdown(record) {
    const menu = (
      <Menu>
        <Menu.Item
          onClick={() => {
            this.setState({ edit: true, recordData: record });
          }}
        >
          <span>{i18next.t("Edit")}</span>
          <Icon className={"view-details-style"} type="edit" />
        </Menu.Item>
        <Menu.Item>
          <Popconfirm
            title={i18next.t("Are you sure delete this Ticket Category?")}
            onConfirm={() => this.deleteRecord(record)}
            okText={i18next.t("Yes")}
            cancelText={i18next.t("No")}
          >
            <a href="#" style={{ color: "rgba(0, 0, 0, 0.65)" }}>
              {i18next.t("Delete")}
              <Icon className={"delete-account-style"} type="delete" />
            </a>
          </Popconfirm>
        </Menu.Item>
      </Menu>
    );
    return (
      <Dropdown overlay={menu}>
        <Button size="small" style={{ borderWidth: 0 }}>
          <Icon item={record} type="more" />
        </Button>
      </Dropdown>
    );
  }
  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={i18next.t(`Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={
            this.props.context.curr_dir === "ltr" &&
            this.props.context.curr_lang === "en"
              ? { width: 100, marginRight: 8 }
              : { width: 100, marginLeft: 8 }
          }
        >
          {i18next.t("Search")}
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 80 }}
        >
          {i18next.t("Reset")}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: "#d73a31" }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] != null &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text}
      />
    ),
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };
  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  formatData(data) {
    const updated_data = [];
    for (var i = 0; i < data.ivrList.length; i++) {
      var row = {};
      row["key"] = i + 1;
      row["name"] = data.ivrList[i]["name"];
      row["code"] = data.ivrList[i]["code"];
      row["status"] = data.ivrList[i]["status"];
      row["createdOn"] = convertTZToLocal(data.ivrList[i]["createdOn"]);
      row["createdBy"] = data.ivrList[i]["createdBy"];
      row["id"] = data.ivrList[i]["id"];
      updated_data.push(row);
    }
    return updated_data;
  }

  render() {
    let { isFetching } = this.state;
    const columns = [
      {
        title: i18next.t("Name"),
        dataIndex: "name",
        key: "name",
        ...this.getColumnSearchProps("name"),
      },
      // {
      //   title: "Code",
      //   dataIndex: "code",
      //   key: "code",
      //   ...this.getColumnSearchProps("code"),
      // },
      // {
      //   title: "Status",
      //   dataIndex: "status",
      //   key: "status",
      //   ...this.getColumnSearchProps("status"),
      // },
      {
        title: i18next.t("date"),
        dataIndex: "createdOn",
        key: "createdOn",
      },
      // {
      //   title: "created by",
      //   dataIndex: "createdBy",
      //   key: "createdBy",
      // },

      {
        title: i18next.t("Action"),
        dataIndex: "operation",
        render: (text, record) =>
          this.state.data.length >= 1
            ? this.renderActionDropdown(record)
            : null,
      },
    ];

    return (
      <Translation>
        {(t) => (
          <Page title={this.state.edit ? null : t("Manage Ticket Categories")}>
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <div>
                <Row style={{ marginTop: "25px" }}></Row>
                {this.state.edit ? (
                  <CreateTicketCategoryForm
                    editMode={this.state.edit}
                    back={() => {
                      this.setState({ edit: false });
                      this.setState({ ticketCategoryData: null });
                    }}
                    recordData={this.state.recordData}
                  ></CreateTicketCategoryForm>
                ) : (
                  <div>
                    <Button
                      className="button-add-account"
                      onClick={this.addNewTicketCategory}
                      icon="plus"
                    />
                    <span>{t("Add New Ticket Category")}</span>
                    <Table
                      columns={columns}
                      bodyStyle={{
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                        borderRadius: "8px",
                        marginBottom: "25px",
                      }}
                      dataSource={this.state.data}
                      pagination={{
                        position: "bottom",
                        pageSize: 10,
                      }}
                      bordered
                      locale={{
                        emptyText: (
                          <Empty
                            description={i18next.t("Empty")}
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                          />
                        ),
                      }}
                    />
                  </div>
                )}
              </div>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(
  withSharedStateConsumer(withRouter(TicketCategories))
);
